import { useGetList, useResourceContext } from "react-admin";
import objectHash from 'object-hash';

export const statusChoices = [
    { id: 'hangup', name: 'Hangup' },
    { id: 'queued', name: 'Queued' },
    { id: 'success', name: 'Success' },
    { id: 'error', name: 'Error' },
    { id: 'running', name: 'Running'},   
]

export const statusChoicesEdit = [
    { id: 'hangup', name: 'Hangup' },
    { id: 'queued', name: 'Queued' },
]

export const workerTypeChoices = [
    { id: 'transformerVaeProtein2Ligand', name: 'Ligand Prediction for Proteins'},
    // { id: 'vinaDocking', name: 'Vina Docking'}
]

export const workerTypeChoicesIdToName = Object.fromEntries(
    workerTypeChoices.map(value => [value.id, value.name])
)

export const useGetTotals = (filterValues, resource) => {
    const _resource = resource ?? useResourceContext();
    const totalEntries = workerTypeChoices.map(workerTypeChoice => {
        const { total } = useGetList(_resource, {
            pagination: { perPage: 1, page: 1 },
            filter: { ...filterValues, workerType: workerTypeChoice.id },
        });
        return [ workerTypeChoice.id, total ]
    })
    return Object.fromEntries(totalEntries);
};

export const validateForm = (record) =>
    values => {
        const errors = {};
        if (!values.workerType) {
            errors.workerType = 'ra.validation.required';
        }
        if (!values.name) {
            errors.name = 'ra.validation.required';
        }
        if (!values.status) {
            errors.status = 'ra.validation.required';
        } else {
            if (!record?.inputData || record.inputData.proteinFile.content !== values?.inputData?.proteinFile?.content) {
                if (!['queued', 'hangup'].includes(values.status)) {
                    errors.status = 'If you changed or uploaded the input data, you need to set the status to "queued" or "hangup"'
                }
            }
            if (record?.status !== values.status && ['success', 'error', 'running'].includes(values.status)) {
                errors.status = 'You can not change status to "success", "error" or "running"'
            }
        }
        if (!values?.inputData?.proteinFile?.content) {
            errors['inputData.proteinFile.content'] = 'ra.validation.required';
        }
        if (!values?.inputData?.proteinFile?.suffix) {
            errors['inputData.proteinFile.suffix'] = 'ra.validation.required';
        }
        return errors;
    };

const acceptKeys = ['workerType', 'name', 'status', 'public', 'inputData'];

export const transformRecord = (data) => {
    const { originalRecord } = data;
    // console.log(originalRecord);
    const sanitizedData = {};
    for (const key in data) {
        if (acceptKeys.includes(key) && data[key]) {
            if (key === "status" && !['hangup', 'queued'].includes(data[key])) {
                continue;
            }
            if (!originalRecord || objectHash(originalRecord[key]) !== objectHash(data[key])) {
                sanitizedData[key] = data[key];
            }
        }
    }
    return sanitizedData;
};
